import { render, staticRenderFns } from "./movable-panel.vue?vue&type=template&id=017d6d1a&scoped=true"
import script from "./movable-panel.vue?vue&type=script&lang=js"
export * from "./movable-panel.vue?vue&type=script&lang=js"
import style0 from "./movable-panel.less?vue&type=style&index=0&id=017d6d1a&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017d6d1a",
  null
  
)

export default component.exports